import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filterFn',
})
export class FilterFnPipe implements PipeTransform {
	transform(value: any, fn: (obj: any) => any): any {
		return fn(value);
	}
}
